import { loadModules } from 'esri-loader'
import React from 'react';
import ReactDOM from 'react-dom';
import { DateTime } from 'luxon';
import BSLAExternalLinkComponent from '../../helpers/BSLAExternalLinkComponent';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';

const BSLAEPAFRSLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        url: 'https://geodata.epa.gov/arcgis/rest/services/OEI/FRS_INTERESTS/MapServer/23',
        visible: false,
        title: 'Facility Registry System (EPA)',
        popupTemplate: {
            outFields: ['*'],
            title: 'Facility Registry System (EPA)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');
                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="FRS ID" value={atts.REGISTRY_ID} />
                        <BSLAPopupItemComponent label="Facility Name" value={atts.PRIMARY_NAME} />
                        <BSLAPopupItemComponent label="Date Created" value={DateTime.fromMillis(atts.CREATE_DATE).toFormat('MMM dd, yyyy')} />
                        <div className="mt-3 mb-1">
                            {atts.LOCATION_ADDRESS}
                            <br />
                            {atts.CITY_NAME}, {atts.STATE_CODE} {atts.POSTAL_CODE}
                            <br />
                            {atts.COUNTY_NAME} County
                        </div>
                        <BSLAExternalLinkComponent href={atts.FAC_URL} />
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAEPAFRSLayer;
